import { DeliveryNoteParams } from '../../models';

export class DeliveryNoteNotificationsLoad {
  public static readonly type = '[DeliveryNoteNotifications] Load Notifications';
  constructor(public payload: DeliveryNoteParams) {}
}

export class DeliveryNoteNotificationsInitialState {
  public static readonly type = '[DeliveryNoteNotifications] Set Initial State';
}
